import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import { Link } from 'react-router-dom';
import t from '@jetshop/intl';
const StyledBreadcrumbs = /*#__PURE__*/styled('ul')({
  name: "StyledBreadcrumbs",
  class: "s1trcchx"
});
const Breadcrumb = /*#__PURE__*/styled('li')({
  name: "Breadcrumb",
  class: "b1943hhp"
});
export default class Breadcrumbs extends React.PureComponent {
  render() {
    const {
      breadcrumbText,
      parents,
      hideLast,
      className
    } = this.props;

    if (breadcrumbText) {
      let mappedParents = [];

      if (parents && parents.length > 0) {
        mappedParents = parents.reduceRight((acc, parent) => {
          var _a;

          return [...acc, {
            text: (_a = parent.object) === null || _a === void 0 ? void 0 : _a.breadcrumbText,
            path: parent.path
          }];
        }, []);
      }

      const crumbs = [{
        text: t('Home'),
        path: '/'
      }, ...mappedParents, {
        text: breadcrumbText,
        path: null
      }];
      return React.createElement(StyledBreadcrumbs, {
        className: cx(className, hideLast && 'hide-last')
      }, crumbs.map((crumb, index) => crumb.text && React.createElement(Breadcrumb, {
        key: index
      }, !crumb.path ? crumb.text : React.createElement(Link, {
        to: {
          pathname: crumb.path,
          state: {
            type: 'Category'
          }
        }
      }, crumb.text))));
    } else {
      return null;
    }
  }

}

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Breadcrumbs/Breadcrumbs.linaria.css");